import React, { useEffect, useState } from "react";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { StyledUserAccountForm } from "./styles";
import { FullScreenModal } from "../UI/Modal";
import { ChangePasswordFrom } from "../Auth/ChangePasswordForm";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../Auth/hooks/useAuth";
import { Loader } from "../Loader/Loader";
import { useFormik } from "formik";
import { ResourceValidationSchema } from "./utils/schema";
import { useAccount } from "./utils/hooks/useAccount";
import { userActions } from "../../store/actions";
import {
  getLoggedInUserInfo,
  saveSessionToLocal,
} from "../../utils/services/auth";
import { PasswordResetConfirmation } from "../PasswordResetConfirmation";
import { DATE_TIME_FORMAT, TOAST_TIMER } from "../../utils/constants";
import { Alert } from "../UI/Alert";
import moment from "moment";
const UserAccountForm = () => {
  const [showPasswordChangeForm, setShowPasswordChangeForm] = useState(false);
  const [showPasswordUpdatedModal, setShowPasswordUpdatedModal] =
    useState(false);
  const { isLoading: accountfetchActionLoading, fetchCurrentUserDetails } =
    useAuth();
  const {
    createOrUpdateResourceAccount,
    errorMessage,
    hideErrorToast,
    isLoading: accountUpdateActionLoading,
  } = useAccount();
  const { userInfo } = useSelector((store) => store.user).authInfo || {};
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const dispatch = useDispatch();
  const {
    ResourceID = "",
    ResourceName = "",
    AccountType = "",
    Email = "",
  } = userInfo || {};
  const formik = useFormik({
    initialValues: {
      resourceName: ResourceName,
      resourceType: AccountType,
      resourceId: ResourceID,
      resourceEmail: Email,
      resourcePhoneNumber: "",
      resourceCreatedOn: "",
      resourceLastLogin: "",
      resourceLocation: "",
      resourceStatus: "",
    },
    validationSchema: ResourceValidationSchema,
    onSubmit: (values) => {
      createOrUpdateResourceAccount(false, values).then((response) => {
        if (
          response &&
          typeof response === "object" &&
          response.StatusCode === 200
        ) {
          const currentDetails = response.Result;
          const { token } = getLoggedInUserInfo() || userInfo || {};
          const updatedDetails = {
            token,
            userInfo: {
              ...currentDetails,
            },
          };
          dispatch(userActions.setAuthInfo(updatedDetails));
          saveSessionToLocal(updatedDetails);
          setShowSuccessAlert(true);
          window.scrollTo(0, 0);
          setTimeout(() => {
            setShowSuccessAlert(false);
          }, TOAST_TIMER);
        }
      });
    },
  });
  const { setValues } = formik;
  const isLoading = accountUpdateActionLoading || accountfetchActionLoading;
  useEffect(() => {
    fetchCurrentUserDetails(ResourceID).then((resourceDetails) => {
      if (resourceDetails) {
        setValues(resourceDetails);
      }
    });
  }, [fetchCurrentUserDetails, ResourceID, setValues]);

  const inputDisable = true;

  return (
    <StyledUserAccountForm onSubmit={formik.handleSubmit}>
      {showSuccessAlert && (
        <Alert
          type="success"
          message={translate("labels.accountUpdateSuccessMsg")}
          onToastClose={() => {
            setShowSuccessAlert(false);
          }}
        />
      )}
      {errorMessage && (
        <Alert
          type="error"
          message={translate("labels.accountUpdateFailureMessage")}
          onToastClose={hideErrorToast}
        />
      )}
      <header>
        <h1>{translate("pageTitles.myAccount")}</h1>
      </header>
      <div className="card">
        <h1 className="tma_section-title">
          {translate("labels.generalInformation")}
        </h1>

        <div className="tma-form_field_content">
          <div className="tma_form-control">
            <Input
              labelText={translate("labels.accountName")}
              id="resourceName"
              name="resourceName"
              value={formik.values.resourceName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.resourceName &&
                Boolean(formik.errors.resourceName)
              }
              helperText={
                formik.touched.resourceName &&
                Boolean(formik.errors.resourceName) &&
                translate("labels.nameRequired")
              }
            />
          </div>

          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.typeOfAccount")}
              id="resourceType"
              name="resourceType"
              disabled={inputDisable}
              value={formik.values.resourceType}
            />
          </div>

          <div className="tma_form-control">
            <Input
              labelText={translate("labels.phoneNumber")}
              id="resourcePhoneNumber"
              name="resourcePhoneNumber"
              value={formik.values.resourcePhoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 15 }}
              error={
                formik.touched.resourcePhoneNumber &&
                Boolean(formik.errors.resourcePhoneNumber)
              }
              helperText={
                formik.touched.resourcePhoneNumber &&
                formik.errors.resourcePhoneNumber
              }
            />
          </div>

          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.emailId")}
              id="resourceEmail"
              name="resourceEmail"
              disabled={inputDisable}
              value={formik.values.resourceEmail}
            />
          </div>

          <div className="tma_form-control">
            <Input
              labelText={translate("labels.address")}
              id="resourceLocation"
              name="resourceLocation"
              value={formik.values.resourceLocation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.resourceLocation &&
                Boolean(formik.errors.resourceLocation)
              }
              helperText={
                formik.touched.resourceLocation &&
                formik.errors.resourceLocation
              }
              inputProps={{ maxLength: 100 }}
            />
          </div>

          <div className="tma_form-control" style={{ visibility: "hidden" }}>
            <Input
              labelText={translate("labels.website")}
              id="website"
              name="website"
            />
          </div>
        </div>
      </div>
      <div class="card">
        <h1 className="tma_section-title padding-top">
          {translate("labels.accountInformation")}
        </h1>

        <div className="tma-form_field_content">
          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.loginEmail")}
              id="resourceLoginEmail"
              name="resourceLoginEmail"
              disabled={inputDisable}
              value={formik.values.resourceEmail}
            />
          </div>

          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.accountCreatedDate")}
              id="resourceCreatedOn"
              name="resourceCreatedOn"
              disabled={inputDisable}
              value={formik.values.resourceCreatedOn || ""}
            />
          </div>
          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.lastLogin")}
              id="lastLogin"
              name="lastLogin"
              disabled={inputDisable}
              value={moment(new Date()).format(DATE_TIME_FORMAT.DISPLAY)}
            />
          </div>
        </div>
      </div>
      <div class="card no-box">
        <section className="tma_form_actions">
          <Button
            onClick={() => setShowPasswordChangeForm(true)}
            text={translate("labels.changePassword")}
            type="button"
            className={"primary-outline"}
          />
          <Button
            text={translate("labels.saveChanges")}
            className={"tma_app_btn primary-success"}
            type="submit"
          />
        </section>
        {showPasswordChangeForm && (
          <FullScreenModal
            onClose={() => setShowPasswordChangeForm(false)}
            preventBackdropClick={true}
          >
            <ChangePasswordFrom
              onPasswordUpdated={() => {
                setShowPasswordChangeForm(false);
                setShowPasswordUpdatedModal(true);
              }}
            />
          </FullScreenModal>
        )}
        {isLoading && <Loader />}
        {showPasswordUpdatedModal && (
          <PasswordResetConfirmation
            forEmail={Email}
            onClose={() => {
              setShowPasswordUpdatedModal(false);
            }}
          />
        )}
      </div>
    </StyledUserAccountForm>
  );
};

export default UserAccountForm;
